module.exports = require('./src/js/JSONEditor');



//////////////////
// WEBPACK FOOTER
// ./~/jsoneditor/index.js
// module id = 2
// module chunks = 0